<template>
  <div>
    <el-dialog title="选择虚拟用户"
               :visible.sync="dialogFormVisible"
               width="1130px"
               top="10px"
               :close-on-click-modal="false"
               @close="emitClose"
               @open="open()">
      <div class="diag">

        <el-form class="search-wrap"
                 ref="searchForm"
                 :inline="true"
                 :model="query">
          <el-form-item label="昵称"
                        prop="nickname_keyword">
            <el-input v-model="query.nickname_keyword"
                      placeholder="请输入用户ID、昵称或手机号"
                      style="width: 220px"
                      @input="getList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="年级"
                        label-width="70px">
            <el-select v-model="query.educate_years"
                       filterable
                       clearable
                       collapse-tags
                       placeholder="请选择"
                       style="width: 220px"
                       @change="getList(true)">
              <el-option v-for="(item, index) in filter.noteYear"
                         :key="index"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="院校名称"
                        prop="college_keyword">
            <el-input v-model="query.college_keyword"
                      placeholder="请输入院校关键字代码/名"
                      style="width: 220px"
                      @input="getList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="专业"
                        prop="major_keyword">
            <el-input v-model="query.major_keyword"
                      placeholder="请输入专业关键字代码/名"
                      style="width: 220px"
                      @input="getList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="学院"
                        prop="academy_keyword">
            <el-input v-model="query.academy_keyword"
                      placeholder="请输入学院关键字代码/名"
                      style="width: 220px"
                      @input="getList(true)"
                      clearable></el-input>
          </el-form-item>
          <el-form-item label="科目"
                        prop="subject_keyword">
            <el-input v-model="query.subject_keyword"
                      placeholder="请输入科目关键字代码/名"
                      style="width: 220px"
                      @input="getList(true)"
                      clearable></el-input>
          </el-form-item>
        </el-form>
        <div class="table-header"
             style="display:flex; justify-content:flex-end;"
             v-if="isStudent==''">

          <el-form :inline="true"
                   label-width="70px"
                   size="small">
            <el-form-item>
              <el-radio-group v-model="query.user_educate_types"
                              @change="tabChange()">
                <el-radio-button v-for="(item, index) in filter.type"
                                 :key="index"
                                 :label="item.value">
                  {{ item.label }}
                </el-radio-button>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </div>

        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  v-if="results.length >0">
          <el-table-column type="selection"
                           width="50"
                           fixed="left"> </el-table-column>
          <el-table-column label="用户uid"
                           width="80"
                           prop="uid"
                           align="center">
          </el-table-column>
          <el-table-column prop="nickname"
                           label="昵称"
                           width="100"
                           show-overflow-tooltip
                           align="center">
          </el-table-column>
          <el-table-column prop="avatar"
                           label="头像"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <el-avatar :src="scope.row.avatar"
                         style="width:30px;height:30px"></el-avatar>
            </template>
          </el-table-column>
          <el-table-column prop="user_educate_type"
                           label="身份"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.user_educate_type==1"
                      type="warning">学生</el-tag>
              <el-tag v-if="scope.row.user_educate_type==2"
                      type="">学长</el-tag>
            </template>
          </el-table-column>

          <el-table-column prop="academy_name"
                           label="年级"
                           width="90"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.educate_year">{{scope.row.educate_year}}年</span>
              <span v-else>-</span>

            </template>
          </el-table-column>
          <el-table-column prop="academy_name"
                           label="报录信息"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{scope.row.college_name}} | {{scope.row.academy_name}} | ({{scope.row.major_code}}) | {{scope.row.major_name}}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="100"
                           align="center"
                           fixed="right">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToCategoryEdit(scope.row, scope.$index)">编辑</el-button>
              <el-button class="remove-text-button"
                         size="mini"
                         type="text"
                         @click="handleToCategoryRemove(scope.row, scope.$index)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div v-else
             class="noPerson"
             @click="createUser(true)">暂无匹配的学长，点击快速新建</div>
        <div class="footer">
          <el-tag effect="plain"
                  @click="createUser(false)">新建
          </el-tag>
          <el-pagination background
                         layout="total, prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handlePageChange"
                         v-if="results.length >0"></el-pagination>
          <div class="submit"
               v-if="results.length >0">

            <div class="cancle"
                 @click="emitClose()">取消</div>
            <div class="confirm"
                 @click="submit()">确定</div>
          </div>
        </div>

      </div>

    </el-dialog>
    <newVirtualUser :isVisible="userVisible"
                    @close="virtualClose"
                    :detail="rowDetail"
                    :title="title"
                    :topic_college_code="topic_college_code"
                    :topic_college_name="topic_college_name"
                    :topic_major_code="topic_major_code"
                    :topic_major_name="topic_major_name"
                    :topic_subject_code="topic_subject_code"
                    :topic_subject_name="topic_subject_name"
                    :fasterCreate="fasterCreate" />
  </div>
</template>
<script>
import { userIdentityList } from '@/api/read'

import { deleteUserIdentity } from '@/api/senior'
import newVirtualUser from '@/components/dialog/newVirtualUser/index'
export default {
  components: { newVirtualUser },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    product_ids: {
      type: Number,
      default: () => {
        return null
      },
    },
    isStudent: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_college_code: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_college_name: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_major_code: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_major_name: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_subject_code: {
      type: String,
      default: () => {
        return ''
      },
    },
    topic_subject_name: {
      type: String,
      default: () => {
        return ''
      },
    },
  },
  data() {
    return {
      dialogFormVisible: this.isVisible,
      fasterCreate: false,
      query: {
        pageIndex: 1,
        pageSize: 10,
        user_educate_types: '2',
        educate_years: '',
      },
      results: [],
      pageTotal: 0,
      chooseList: [],
      filter: {
        type: [
          { label: '学长', value: '2' },
          { label: '学员', value: '1' },
        ],
        noteYear: [
          { label: '2025年', value: '2025' },
          { label: '2024年', value: '2024' },
          { label: '2023年', value: '2023' },
          { label: '2022年', value: '2022' },
          { label: '2021年', value: '2021' },
          { label: '2020年', value: '2020' },
        ],
      },
      userVisible: false,
      rowDetail: {},
      title: '新建虚拟用户',
    }
  },
  watch: {
    isVisible(val) {
      this.dialogFormVisible = val
    },
    topic_college_code(val) {
      this.query.college_keyword = this.topic_college_name
    },
    topic_major_code(val) {
      this.query.major_keyword = this.topic_major_name
    },
    topic_subject_code(val) {
      console.log('222')
      this.query.subject_keyword = this.topic_subject_name
    },
  },
  methods: {
    virtualClose() {
      this.userVisible = false
      this.getList()
    },
    reset() {
      this.results = []
      this.pageTotal = 0
      this.query.pageIndex = 1
    },
    tabChange() {
      this.reset()
      this.getList()
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
    emitClose() {
      this.$emit('close')
    },
    submit() {
      this.$emit('virtChoose', this.chooseList)
      this.emitClose()
    },
    createUser(type) {
      this.fasterCreate = type
      console.log('this.fasterCreate', this.fasterCreate)
      this.title = '新建虚拟用户'
      this.userVisible = true
    },
    open() {
      this.getList()
    },
    getList(reset) {
      if (reset) {
        this.query.pageIndex = 1
      }
      if (this.isStudent == '学生') {
        this.query.user_educate_types = '1'
      } else if (this.isStudent == '学长') {
        this.query.user_educate_types = '2'
      }
      userIdentityList(this.query).then((res) => {
        this.results = res.list
        this.pageTotal = res.count
      })
    },
    handleToCategoryEdit(row) {
      this.title = '编辑虚拟用户'
      this.rowDetail = row
      this.userVisible = true
    },
    handleToCategoryRemove(row) {
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          deleteUserIdentity({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.getList()
          })
        })
        .catch(() => {})
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.getList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.getList()
    },
  },
}
</script>
<style  lang="less" scoped>
::v-deep .el-dialog__header {
  background: #ebeef5;
}
.diag {
  height: 820px;
  .footer {
    display: flex;
    justify-content: space-between;
    margin-top: 35px;
    .submit {
      display: flex;
      .cancle {
        margin-right: 10px;
        text-align: center;
        width: 56px;
        height: 36px;
        font-size: 14px;
        color: #909399;
        line-height: 36px;
        border-radius: 4px 4px 4px 4px;
        border: 1px solid #dcdfe6;
      }
      .confirm {
        font-size: 14px;
        color: #ffffff;
        text-align: center;
        width: 56px;
        height: 36px;
        line-height: 36px;
        background: #409eff;
        border-radius: 4px 4px 4px 4px;
      }
    }
  }
  .noPerson {
    cursor: pointer;
    text-align: center;
    color: #409eff;
  }
}
</style>